import type { CSSProperties, ReactNode } from "react";
import { Descriptions, theme, type DescriptionsProps } from "antd";
import "./detail-layout.css";

/** Shared reading layout for customer-facing merchant details. */
export function DetailSurface({ children, className = "" }: { children: ReactNode; className?: string }) {
  const { token } = theme.useToken();
  const style = {
    "--detail-bg": token.colorBgContainer,
    "--detail-fill": token.colorFillQuaternary,
    "--detail-line": token.colorBorderSecondary,
    "--detail-muted": token.colorTextSecondary,
    "--detail-text": token.colorText,
    "--detail-accent": token.colorPrimary,
    "--detail-radius": `${token.borderRadius}px`,
  } as CSSProperties;
  return <div className={`merchant-detail ${className}`} style={style}>{children}</div>;
}

export function DetailSection({ title, children, style, extra }: { title: ReactNode; children: ReactNode; style?: CSSProperties; extra?: ReactNode }) {
  return <section className="merchant-detail-section" style={style}>
    <div className="merchant-detail-section-heading"><h3>{title}</h3>{extra && <div>{extra}</div>}</div>
    {children}
  </section>;
}

export function DetailFields(props: DescriptionsProps) {
  const columns = props.column || { xs: 1, sm: 2 };
  let last = 1;
  const resolvedColumns = typeof columns === "number" ? columns : Object.fromEntries(
    (["xs", "sm", "md", "lg", "xl", "xxl"] as const).map(key => {
      last = columns[key] ?? last;
      return [key, last];
    }),
  );
  return <Descriptions {...props} className={`merchant-detail-fields ${props.className || ""}`} layout="vertical" colon={false} size="small" column={resolvedColumns} />;
}
